import { render, staticRenderFns } from "./addMaterialDeviceParam.vue?vue&type=template&id=397d53bb&scoped=true"
import script from "./addMaterialDeviceParam.vue?vue&type=script&lang=js"
export * from "./addMaterialDeviceParam.vue?vue&type=script&lang=js"
import style0 from "./addMaterialDeviceParam.vue?vue&type=style&index=0&id=397d53bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397d53bb",
  null
  
)

export default component.exports